import { createStyles, Theme } from '@material-ui/core/styles';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(6),
      minHeight: 0,
      padding: spacing(6),
    },

    rootNoPadding: {
      gap: 0,
      padding: 0,
    },
  });
